import React from 'react';
import { HydrateLanding } from './pages/HydrateLanding';
export function App() {
  return <HydrateLanding data-id="element-0" />;
}